export * from "./query";
export const buildUrl = (sdk, apiVersion, path) => {
    return `${sdk.urls.advancedQueryToolBaseUrl}/${apiVersion}/${path}`;
};
//# sourceMappingURL=index.js.map